import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";

type RespBonificacao = {
  sucesso: boolean;
  mensagem: string;
  retorno?: { percentualBonificacao: number; legado: boolean };
};

@Injectable({ providedIn: "root" })
export class BonificacaoService {
  constructor(private http: HttpClient) {}

  calcularBonificacaoSemAcrescimoBodyShop(
    estimativaId: number,
    percentualMargemContribuicao: number,
  ): Observable<RespBonificacao> {
    const params = new HttpParams()
      .set("estimativaId", String(estimativaId))
      .set(
        "percentualMargemContribuicao",
        String(percentualMargemContribuicao),
      );
    return this.http.get<RespBonificacao>(
      `${environment.API_PRICE}/Bonificacao/CalcularBonificacaoSemAcrescimoBodyShop`,
      { params },
    );
  }
}
